import { useSelector } from 'react-redux'

import routes from '@tabeeb/routes'
import { TenantPermission } from '@tabeeb/enums'
import { getFormsTitle } from '@tabeeb/modules/appConfigState/selectors'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'

import NavbarTab from '../NavbarTab'

const Forms = ({ ...rest }) => {
  const formsTitle = useSelector(getFormsTitle)
  const display = useSelector((state) => hasTenantPermission(state, TenantPermission.ViewForms))

  const props = {
    item: {
      label: formsTitle,
      to: Forms.to,
    },
    display,
    ...rest,
  }

  return <NavbarTab {...props} />
}

Forms.to = routes.forms

export default Forms
